import ArticleDsfr from "components/templates/articleDsfr/ArticleDsfr";
import elementsTypes from "utils/elementsTypes";

export default {
  key: "ARTICLEDSFR",
  label: "Article (DSFR)",
  Component: ArticleDsfr,
  containsOnlyOnePage: true,
  initialContents: [
    {
      key: "headerElement",
      type: elementsTypes.DYNAMIC_LIST,
      value: "",
      children: [
        {
          key: "limit",
          value: "1",
        },
        {
          key: "contentType",
          value: [elementsTypes.IMAGE_BLOCK, elementsTypes.VIDEO].toString(),
        },
      ],
    },
    {
      key: "displaySummary",
      type: elementsTypes.ALONE_CHECKBOX_SUMMARY,
      value: "true",
    },
    {
      key: "dynamicPart",
      type: elementsTypes.DYNAMIC,
      value: "",
      children: [],
    },
  ],
};
